<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：フォルダ一覧画面(STFM02C22FolderListModal)                                          _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div class="overlay"
    :class="[isFolderListShow ? showClass : hideClass]"
    id="popup-folderlist"> 
    <div class="popup" style="width: 654px">
      <div class="popup-head">フォルダ一覧</div>
      <div class="popup-body blue">
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <error-message :errors="errors"></error-message>
        </p>
        <div class="mt-10px">
          <p>フォルダを選択してください。</p>
        </div>
        <div class="table-wrap table-cabinet">
          <div class="table-scroll-header">
            <table class="table-select single-select">
              <colgroup>
                <col style="width: auto;">
              </colgroup>
              <thead>
                <tr>
                  <th class="sort alignleft">名称
                    <div class="sort-toggle">
                      <button class="sort-toggle-desc on one-toggle" type="button">desc</button>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-scroll-body table-scroll-body-folderlist h-210px auth-user-table">
            <table id="folderlistTable" class="table-select table-select-folderlist single-select hover-on">
              <colgroup>
                <col style="width: auto; background-color: #fff;">
              </colgroup>
              <tbody class="td-h-60px">
                <template v-for="(folderInfo,index) in folderList" :key="folderInfo.folderpath">
                  <tr :folderlistindex="folderInfo.depth" 
                    class="" 
                    @click="dataItemClicked(index,$event)" 
                    :ref="`data`+index"
                    :id="`dataline`+index"
                    :tabindex="createTabindex(index)">
                    <td class="table-scroll-body-folderlist-td">
                      <template v-for="n in folderInfo.depth" :key="n">
                        <span v-if="createIndent(n,folderInfo)" class="folder-state-ico"></span>
                      </template>
                      
                      <span v-if="(!folderInfo.isabyss && !isShowChild(index))"
                        :id="`data`+index"  class="folder-state-ico ico-right" @click="onoff(index,'data'+index)"></span>
                      <span v-else-if="(!folderInfo.isabyss && isShowChild(index))"
                        :id="`data`+index"  class="folder-state-ico ico-down" @click="onoff(index,'data'+index)"></span>
                      {{folderInfo.name}}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button class="frm-btn strong large" 
              @click="execBtnClicked()" 
              :id ="folderlist-exec-btn"
              :tabindex="0">確定</button>
              <button class="frm-btn large" 
              @click="canselBtnClicked()"
              :id ="folderlist-cansel-btn" 
              :tabindex="0" 
              @blur="onblur">キャンセル</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Common from "@/util/common.js";
  import ErrorMessage from '@/components/ErrorMessage.vue'
  import {API_STFMFM02C22} from '@/api/Modules/FM02/STFMFM02C22.js';
  import { mapGetters, mapMutations } from "vuex";
  import _ from "lodash";

  export default{
    name:'STMF02C22',
    components:{
      ErrorMessage,
    },
    watch:{
      isFolderListShow: {
        immediate: true,
        handler(newVal){
          if(newVal == true){
            this.initialize().then(()=>{
              this.handleBodyScrollOnModalStateChange(newVal)
            })
          } else {
            this.handleBodyScrollOnModalStateChange(newVal)
          }

        }
      },
      folderList:{
        handler(newVal){
          this.$nextTick(function(){
            // データ行表示切替
            this.showFolderName();
            return;
          });
        },
        deep:true,
      },
      selectedItem:{
        handler(newVal){
          this.$nextTick(function(){
            // 選択表示状態更新
            this.dispSelectedItem();
            if(this.isInit){
              // 初期表示時のみ呼び出し
              this.initfocus();
              this.initScroll();
              this.isInit = false;
            }
          })
        }
      }
    },
    props:{
      currentFolder:{
        type: Object,
        default: null,
      },
      isFolderListShow:{
        type: Boolean,
        required: true,
        default:false,
      },
    },
    data(){
      return{
        showClass: "show",
        hideClass: "hide",
        openClass: " ico-open",
        closeClass:" ico-right",
        selectedItem: null,
        destFolderInfo:{
          name:"",
          folderPath:"",
          folderkey:"",
        },
        folderList:[],
        errors: [],
        isInit: false,
      };
    },
    methods:{
      ...mapMutations("businessModule",["processDialogue","handleBodyScrollOnModalStateChange"]),
      // 初期表示時サブフォルダ表示判定(v,>アイコン切替)
      isShowChild(idx){
        // フォルダリストの終端の場合
        if(idx+1 == this.folderList.length){
           return false;
        }
        return this.folderList[idx+1].isshow;
        
      },
      // フォルダ名選択状態切替
      dispSelectedItem(){
        // フォルダ名表示行選択状態初期化(classからselectedを削除)
        let textList = document.getElementById('folderlistTable');
        var li02 = textList.getElementsByTagName('tr');
        for(let i = 0;i<li02.length;i++ ){
          if(li02[i].classList.contains("selected")){
            li02[i].classList.remove("selected");
          }
        }
        
        // 選択中のパスから要素の番号を抽出
        for(let i = 0; i< this.folderList.length;i++){
          if(this.folderList[i].folderpath == this.selectedItem){
            // フォルダ名選択状態
            li02[i].classList.add("selected");
            break;
          }
        }
      },
      // 初期表示時フォルダ名表示・非表示切替
      showFolderName(){
        let textList = document.getElementById('folderlistTable');
        var li02 = textList.getElementsByTagName('tr');
        if(this.folderList != null ){
          for(let i = 0;i<this.folderList.length;i++){
            if(i>0){
              // 最上位フォルダ以下のフォルダ名表示・非表示セット
              if(!this.folderList[i].isshow){
                li02[i].classList.add(this.hideClass);
              }
            }
          }
        }
      },
      createTabindex(idx){
        if(this.folderList[idx].isselected){
          return "0";
        }
        return "-1";
      },
      // 初期表示時スクロール処理
      initScroll(){
        // 選択中の要素(class名にselectedがついている)を取得
        let textList = document.getElementById('folderlistTable');
        let selectedEl = textList.getElementsByClassName('selected');
        
        if(selectedEl == null){
          return;
        }
        selectedEl[0].scrollIntoView();

      },
      initialize(){
        this.processDialogue(true);
        let param={
          folderPath:this.currentFolder.folderPath,
          folderKeyTreeList:null,
        }
        
        return API_STFMFM02C22(param).then(
          (response)=>{
            if(response.result === "0000"){
              let folderlist = response.folderKeyTreeList
              if(folderlist != null){
                for(let i = 0 ;i<folderlist.length;i++){
                  let dispdata = {
                    depth:folderlist[i].level,
                    isabyss:folderlist[i].bottomFlag,
                    name:folderlist[i].folderName,
                    isshow:folderlist[i].dispFlag,
                    isselected:folderlist[i].openFlag,
                    folderpath:folderlist[i].folderPath,
                    folderkey:folderlist[i].tzaffmFolderKey
                  }
                  this.folderList.push(dispdata);
                }
                // 初期選択表示
                this.setSelectedFolder();
                this.isInit = true;
              }else{
                // 正常コードでもフォルダ情報がnullの場合はシステムエラー(MTCL0999)
                this.errors.push(
                  Common.createError(
                    "MTCL0999",
                    Common.getMessage("MTCL0999", [])
                  )
                );
              }
            }
            else{
              // エラー表示
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
            this.processDialogue(false);
          }
        );
      },
      /*********************/
      /* 確定クリック  */
      /*********************/
      execBtnClicked(){
        // エラー表示領域初期化
        this.clearError();
        
        if (this.selectedItem == null) {
          // エラー表示
          this.errors.push(
            Common.createError("MTCL1034",Common.getMessage("MTCL1034", ["フォルダ"]))
          );  
          return;
        }
          // selectedのクラスに表示中のフォルダ情報を取得
        var tmp = this.folderList.filter(item => item.folderpath === this.selectedItem);
        if(tmp.length === 1){
          // 該当フォルダ情報を渡す。
          this.destFolderInfo.name = tmp[0].name;
          this.destFolderInfo.folderPath = tmp[0].folderpath;
          this.destFolderInfo.folderkey = tmp[0].folderkey;
          this.deleteParams();
          this.$emit("close-stfmf02c22",true,this.destFolderInfo);
        }
      },
      /*********************/
      /* キャンセルクリック  */
      /*********************/
      canselBtnClicked(){
          this.clearError();
          this.deleteParams();
          this.$emit("close-stfmf02c22",false,this.destFolderInfo);
      },
      /*********************/
      /* データ行クリック  */
      /*********************/
      dataItemClicked(infoid,event){
        // アイコン(>やv)をクリックした場合
        if(event.target.id == ("data"+infoid)){
          return;
        }
        // 引数をフォルダパスからindex値に変更
        if(this.selectedItem === this.folderList[infoid].folderpath){
          this.selectedItem = null;
        }else{
          this.selectedItem = this.folderList[infoid].folderpath;
        }
      },
      /*********************/
      /* onoff切替          */
      /*********************/
      onoff(idx,targetid){
        // 属性から絞り込み
        // DOM更新
        let textList = document.getElementById('folderlistTable');
        var li02 = textList.getElementsByTagName('tr'); // フォルダ名表示領域
        /* 自分に ico-down(開いている) or ico-right(閉じている) */
        var icons = document.getElementById(targetid);
        // 自分自身の階層取得
        const depth = Number(li02[idx].getAttribute("folderlistindex"));
        if (icons.classList.contains("ico-down")) {
          // v -> >
          /* 開いている場合は問答無用ですべてoff */
          let lastlevel = depth;
          for (let i = 0; i < li02.length; i++) {
            // クリックした行より下の行
            if(i > idx){
              lastlevel = Number(li02[i].getAttribute("folderlistindex"));
              if(lastlevel <= depth){
                // クリックした行と同一階層または浅い階層に来たら終了
                break;
              }
              /* 非表示でない配下をすべて非表示 */
              if (!icons.classList.contains("hide")) {
                li02[i].classList.add('hide');
              }
            }
          }
        } else {
          // > -> v
          // 要素の階層を取得
          /* 閉じてる場合は自分自身の直下の階層だけ表示 */
          // フォルダ名のデータ件数分回す
          let lastlevel = depth;
          for (var i = 0; i < li02.length; i++) {
            // 探索対象階層のフォルダ
            if(i > idx){
              let nowlevel =Number(li02[i].getAttribute("folderlistindex")); 
              if(nowlevel < lastlevel){
                break;
              }
              if(depth + 1 == nowlevel){
                /* 非表示でない配下をすべて非表示 */
                li02[i].classList.remove('hide');
                var sp02 = li02[i].getElementsByTagName('span');
                for (let j = 0; j < sp02.length; j++) {
	                if (sp02[j].classList.contains("ico-down")) {
	                  sp02[j].classList.remove('ico-down');
	                  sp02[j].classList.add('ico-right');
	                } 
                }
                lastlevel = nowlevel;
              }
            }
          }
        }
        /* 自分のクラスのボタンを変える */
        icons.classList.toggle('ico-down');
        icons.classList.toggle('ico-right');
      },
      // **********************************************
      // * エラーメッセージ初期化
      // **********************************************
      clearError(){
        this.errors = [];
      },
      // **********************************************
      // * 選択済みフォルダパス取得
      // **********************************************
      setSelectedFolder(){
        let selecteddata = this.folderList.find(dispinfo => dispinfo.isselected == true);
        this.selectedItem = selecteddata.folderpath;
      },
      // **********************************************
      // * 画面非表示時各パラメータ初期化
      // **********************************************
      deleteParams(){
        this.isInit = false;
        this.selectedItem = null;
        this.folderList = [];
      },
      // **********************************************
      // * フォーカス初期化
      // **********************************************
      initfocus(){
        let textList = document.getElementById('folderlistTable');
        var li02 = textList.getElementsByTagName('tr');
        li02[0].focus();
      },
      onblur(e){
        if(!e) return;
        e.preventDefault();
        this.initfocus();
      },
      createIndent(spcnt,folderdata){
        let rtn = false;
        if(folderdata.isabyss){
          // 最下層なら階層の深さ分だけ半角空白生成
          rtn = true;
        }else{
          // 階層の深さ-1だけ半角空白生成(>vマークが入るため)
          if(spcnt < folderdata.depth){
            rtn = true;
          }
        }
        return rtn;
      }

    },
  }
</script>
<style scoped>
.table-select.single-select .selected {
  background-image: url(../assets/images/denchouhou/icon_caret_select.png);
}

.ico-down:before {
  background-image: url(../assets/images/denchouhou/icon_d-down.png);
}

.ico-right:before {
  background-image: url(../assets/images/denchouhou/icon_d-right.png);
}
/*
.table-cabinet th,
.table-cabinet td {
  height: 32px !important;
  padding-top: 0;
  padding-bottom: 0;
}
*/
.table-cabinet.no-select-ico tr td:first-child {
  padding-left: 0;
}

.table-cabinet.no-select-ico tr td:last-child {
  padding-left: 10px;
}

.table-cabinet .folder-state-ico:before, 
.table-cabinet .headline-ico:before {
    width: 14px;
    height: 14px;
}

.table-scroll-body-folderlist {
  overflow-x: scroll;
  overflow-y: scroll;
}

.table-select-folderlist {
  table-layout: auto;
}

.table-scroll-body-folderlist-td {
  height: 60px;
  white-space: nowrap;
}

.table-select-folderlist tr {
  display: table-row;
  border-bottom: none;
}


.table-select-folderlist tr.hide{
  display: none;
}

.table-select-folderlist tr.selected {
  background: 5px center no-repeat #A6CCFE;
}

/*
.table-select-folderlist tr.show {
  display: table-row;
}
*/


</style>